/**
 * Infinite Options Property Fix
 * Ensures all product properties are captured when adding to cart
 * Works with Infinite Options app and any other property inputs
 */

(function() {
  'use strict';
  
  // Only run once
  if (window.infiniteOptionsFixApplied) return;
  window.infiniteOptionsFixApplied = true;
  
  function initInfiniteOptionsFix() {
    console.log('Infinite Options Fix: Initializing');
    
    // Store the original FormData constructor
    const OriginalFormData = window.FormData;
    
    // Override FormData to include all properties
    window.FormData = function(form) {
      // Create FormData with original constructor
      const formData = new OriginalFormData(form);
      
      // Only process if this is a product form
      if (form && form.action && form.action.includes('/cart/add')) {
        
        // Look for ALL property inputs
        const propertyInputs = document.querySelectorAll(`
          input[name^="properties["]:checked,
          input[name^="properties["]:not([type="radio"]):not([type="checkbox"]),
          select[name^="properties["],
          textarea[name^="properties["]
        `);
        
        // Also check Infinite Options container specifically
        const infiniteOptionsInputs = document.querySelectorAll(`
          #infiniteoptions-container input:checked,
          #infiniteoptions-container input:not([type="radio"]):not([type="checkbox"]),
          #infiniteoptions-container select,
          #infiniteoptions-container textarea
        `);
        
        // Combine both sets of inputs (remove duplicates)
        const allPropertyInputs = [...new Set([...propertyInputs, ...infiniteOptionsInputs])];
        
        allPropertyInputs.forEach(function(input) {
          // Skip if no name
          if (!input.name) return;
          
          // Handle different input types
          if (input.type === 'checkbox') {
            // For checkboxes, only add if checked
            if (input.checked && !formData.has(input.name)) {
              formData.set(input.name, input.value || 'on');
            }
          } else if (input.type === 'radio') {
            // For radio buttons, only add if checked
            if (input.checked && !formData.has(input.name)) {
              formData.set(input.name, input.value);
            }
          } else if (input.value) {
            // For all other inputs (text, select, textarea, etc.)
            if (!formData.has(input.name)) {
              formData.set(input.name, input.value);
            }
          }
        });
        
        // Debug logging (remove for production)
        if (window.location.search.includes('debug=true')) {
          const props = [];
          for (let [key, value] of formData.entries()) {
            if (key.includes('properties[')) {
              props.push(`${key}: ${value}`);
            }
          }
          if (props.length > 0) {
            console.log('Infinite Options Fix: Properties being sent:', props);
          }
        }
      }
      
      return formData;
    };
    
    // Copy static methods and prototype
    Object.setPrototypeOf(window.FormData, OriginalFormData);
    Object.setPrototypeOf(window.FormData.prototype, OriginalFormData.prototype);
    
    console.log('Infinite Options Fix: Ready');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteOptionsFix);
  } else {
    initInfiniteOptionsFix();
  }
})();